$(function () {
    // homepage fold
    $('.slider-fold .slides').owlCarousel({
        loop: true,
        nav: false,
        dots: false,
        items: 1,
        animateIn: 'fadeIn',
        animateOut: 'fadeOut',
        mouseDrag: false,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplaySpeed: 1000
    });

    // homepage slider
    $('.hslider').owlCarousel({
        loop: true,
        nav: false,
        dots: true,
        items: 1,
        stagePadding: 80,
        mouseDrag: false,
        autoplayHoverPause: true,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplaySpeed: 1000,
        responsive: {
            0: {
                stagePadding: 40,
            },
            520: {
                stagePadding: 60,
            },
            1024: {
                stagePadding: 80,
            }
        }
    });

    // anchor links on some collection pages
    $('.chart-inpagelink a').on('click', function (e) {
        e.preventDefault();
        var index = $(this).index();
        console.log(index);

        $("html, body").animate({scrollTop: $('.main-product-wrapper').eq(index).offset().top - 200}, 1000);
    });

    // popup video
    $('.popup-video').magnificPopup({
        type: 'iframe'
    });

    // active state for product variation
    $('body.template-product .swatch').each(function () {
        // active states for swatches (sometimes there are 2)
        $(this).find('.swatch-element label').on('click', function () {
            //console.log($(this).parents('.swatch').find('.swatch-element'));
            //console.log($(this).parent());
            $(this).parents('.swatch').find('.swatch-element').removeClass('active');
            $(this).parent().addClass('active');

            // check if there is inventory-quantity to update quantity
            if ($('.inventory-quantity').length) {
                // grab active product sku
                setTimeout(function () {
                    var sku = $('.product-info .variant-sku').text();
                    var quantity = $('.availability .hidden span.' + sku).text();

                    // check if unavailable
                    if ($('#AddToCartText').text() == 'Unavailable') {
                        // update quantity count to 0 since not available
                        $('.availability .inventory-quantity').text('0');
                    } else {
                        // update quantity count for active product
                        $('.availability .inventory-quantity').text(quantity);
                    }
                }, 250);
            }
        });
    });

    // toggle search in header
    $('header .links a.search').on('click', function () {
        $(this).siblings('.form-holder').toggleClass('active');
    });

    // make anything in nav/footer that ends in pdf extension have target blank
    $('.site-nav__dropdown a, .mobile-nav__sublist a, footer a').each(function () {
        var href = $(this).attr('href');
        var url = href.split('?')[0];
        var extension = url.substr((url.lastIndexOf('.') + 1));
        if (extension == 'pdf') {
            $(this).attr('target', '_blank');
        }
    });

    // mobile menu resources overlay
    $('#MobileNav .resources-popup').on('click', function () {
        $('#MobileNavTrigger').click();
    });

    $(window).on("resize scroll", function () {
        lazyLoadBg();
    });

    lazyLoadBg();

    function lazyLoadBg() {
        $('[data-lazyload]').each(function (i, el) {
            var el = $(this);
            var type = el.data("lazyload");
            var src = el.data("lazyload-src");
            //load up images 300 px before viewport
            var viewOffset = 300;
            if (type == "bg") {
                viewOffset = 0
            }
            var offsetTop = el.offset().top;
            var elementTop = offsetTop - viewOffset;
            var elementBottom = elementTop + el.outerHeight();
            var viewportTop = $(window).scrollTop();
            var viewportBottom = viewportTop + $(window).height();
            var elementSrollTop = offsetTop - viewportTop;
            var inView = (elementBottom > viewportTop && elementTop < viewportBottom) || (elementSrollTop < viewOffset);

            if (inView) {
                if (type === "bg") {
                    el.css('background-image', 'url(' + src + ')');
                }
                if (type === "img") {
                    el.attr("src", src);
                }
            }
        });
    }

    // allow embed youtube (playlist, etc)
    $.extend(true, $.magnificPopup.defaults, {
        iframe: {
            patterns: {
                youtube: {
                    index: 'youtube.com',
                    id: function(src)
                    {
                        // link pattern
                        var mt = src.match(/v=([^&]+)(&(.*))?/);
                        if (mt)
                            return mt[1] +'?'+ mt[3];

                        // embed pattern
                        mt = src.match(/embed\/([^\?\/]+)(\?(.*))?/);
                        if (mt)
                            return mt[1] +'?'+ mt[3];
                    },
                    src: '//www.youtube.com/embed/%id%&autoplay=1&rel=0'
                }
            }
        },

        // when element is focused, some mobile browsers in some cases zoom in
        // it looks not nice, so we disable it:
        callbacks: {
            beforeOpen: function() {
                if ($(window).width() < 700)
                    this.st.focus = false;
            }
        }
    });
});